import DVCore from "./core/DVCore";

const AdminUsersAPI = {};

AdminUsersAPI.baseURL = "/api/admin/users/";

AdminUsersAPI.reset2fa = (username, onSuccess, onFail, onError = null) =>
    DVCore.post(AdminUsersAPI.baseURL + encodeURIComponent(username) + "/reset-2fa",
                null, onSuccess, onFail, onError);

export default AdminUsersAPI;
